import { ReactElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import {
  ContainerBoxMachines, ContainerErrorMachines, ErrorImg, ErrorMachinesButton,
} from '../style';
import disconnectedIcon from '../../../../assets/img/cool_ico/Disconnected.svg';
import refreshIcon from '../../../../assets/img/cool_ico/Refresh.svg';
import { colors } from '~/styles/remoteControlColors';
import { shadows } from '~/styles/remoteControlShadows';

interface RetryButtonProps {
  onClick: () => void;
  text: string;
  altImage: string;
}

export function RetryButton({ onClick, text, altImage }: RetryButtonProps): JSX.Element {
  return (
    <ErrorMachinesButton type="button" onClick={onClick}>
      {text}
      <img src={refreshIcon} alt={altImage} />
    </ErrorMachinesButton>
  );
}

export function ErrorMachines({ customText }: { customText?: string }): ReactElement {
  const { t } = useTranslation();
  const isDesktop = window.matchMedia('(min-width: 770px)').matches;

  function onRetry(): void {
    window.location.reload();
  }

  const defaultText = isDesktop ? 'erroCarregarMaquinasComQuebra' : 'erroCarregarMaquinasSemQuebra';

  return (
    <div style={{ padding: isDesktop ? '0' : '0 30px' }} data-testid="error-machine-container">
      <ContainerBoxMachines style={{ padding: '20px', boxShadow: shadows.shadow01 }}>
        <ContainerErrorMachines>
          <ErrorImg src={disconnectedIcon} alt="img-disconnected" />
          <p style={{
            textAlign: 'center',
            color: colors.Grey500,
            fontSize: '12px',
            fontWeight: '400',
            maxWidth: '350px',
          }}
          >
            <Trans
              i18nKey={customText ?? defaultText}
              components={{ br: <br /> }}
            />
          </p>
          <RetryButton onClick={onRetry} text={t('recarregarPagina')} altImage={t('recarregarPagina')} />
        </ContainerErrorMachines>

      </ContainerBoxMachines>
    </div>
  );
}
